import {getElementCoords, Observable, storedScrollPos} from './utils';

export const ScrollPositionController = (() => {
    history.scrollRestoration = 'manual';
    const scrollPosition = Observable(storedScrollPos.getScrollPos());

    const initScrollPosition = () => {
        if (history.state !== null && history.state <= history.length) {
            window.scrollTo(0, Number(scrollPosition.getValue()));
        } else {
            window.scrollTo(0, 0);
            scrollPosition.setValue(0);
            history.replaceState(history.length, '', window.location.href);
        }
    };

    const initEventListener = () => {
        const setCalculatedGutter = () => {
            const body = document.querySelector('body');
            const navigation = document.querySelector('#navigation');
            const gutter = Number(getComputedStyle(document.documentElement)
                .getPropertyValue('--grid-gutter-width')
                .replace('px', ''));

            if (body.style.length === 0) {
                const calculatedPos = getElementCoords(navigation).top - gutter;
                scrollPosition.setValue(calculatedPos);
            }
        };

        window.addEventListener('scroll', function () {
            setCalculatedGutter();
        }, false);
    };

    let timer;
    scrollPosition.onChange(scrollPos => {
        if (scrollPos !== null) {
            clearTimeout(timer);
            timer = setTimeout(storedScrollPos.setScrollPos, 50, scrollPos);
        }
    });

    setTimeout(initScrollPosition, 0);
    setTimeout(initEventListener, 0);

    /**
     * @typedef {{
     *     scrollPosition: Observable
     * }}
     */
    return {
        scrollPosition
    };
})();
